import PhotoPricingItemsSelector from './PhotoPricingItemsSelector';

export default PhotoPricingItemsSelector;
